<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
const getRequest = function(urlStr) {
  let url;
  if (typeof urlStr == "undefined") {
    url = decodeURI(location.search); //获取url中"?"符后的字符串
  } else {
    url = "?" + urlStr.split("?")[1];
  }
  let theRequest = new Object();
  if (url.indexOf("?") != -1) {
    let str = url.substr(1);
    let strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURIComponent(
        strs[i].split("=")[1]
      );
    }
  }
  return theRequest;
};

import { setFrom, FromKey } from "./utils/auth";
export default {
  name: "app",
  created() {
    let params = getRequest();
    let from = params[FromKey];
    if (from) {
      setFrom(from);
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "微软雅黑", "sans-serif", "Glyphicons Halflings", Verdana;
  font-weight: normal;
  box-sizing: border-box;
}

a,
a:visited,
a:active,
a:hover {
  text-decoration: none;
  color: inherit;
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.clearfix::after {
  content: "";
  clear: both;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100%;
}
</style>
